import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.common.white,
    borderRadius: '8px',
    width: '420px',
    overflow: 'hidden',
    boxShadow: theme.palette.shadow.cardBoxShadow,
    '& a': {
      textDecoration: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  alignment: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardInfo: {
    height: '200px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '1.56rem',
    paddingRight: '1.56rem',
  },
  imageContainer: {
    maxHeight: '110px',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
  },
  topLine: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  dateRange: {
    marginTop: '0.625rem',
    marginBottom: '0.625rem',
    '& span': {
      ...theme.typography.formTags,
      color: theme.palette.grey.dark,
    },
  },
  headline: {
    marginBottom: 'auto',
    maxWidth: '280px',
    color: theme.palette.secondary.main,
  },
  tagsRow: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    top: '1.275rem',
    paddingLeft: '1.56rem',
    paddingRight: '1.56rem',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      top: '0.75rem',
      paddingLeft: '1.25rem',
      paddingRight: '1.25rem',
    },
  },
  tagsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      gap: '6px',
    },
  },
  tag: {
    ...theme.typography.formTags,
    padding: '5px 10px',
    borderRadius: '6px',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.black,
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: '22px',
    marginBottom: theme.spacing(1),
  },
  fieldText: {
    fontWeight: '500',
    color: theme.palette.grey.dark,
    marginLeft: '0.375rem',
  },
  ctaButton: {
    width: '100%',
    minHeight: '50px',
    padding: '0',
    borderTop: `1px solid ${theme.palette.grey.light}`,
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  logo: {
    height: '6.25rem',
    width: '6.25rem',
    border: `2px solid ${theme.palette.grey.warm}`,
    position: 'absolute',
    display: 'flex',
    overflow: 'hidden',
    flexShrink: 0,
    borderRadius: '50%',
    objectFit: 'contain',
    backgroundColor: theme.palette.common.white,
    bottom: '-3.125rem',
    right: '1.56rem',
    [theme.breakpoints.down('sm')]: {
      height: '3.75rem',
      width: '3.75rem',
      bottom: '-1.875rem',
    },
  },
}))
export default useStyles
